export const social = [
  { label: "LinkedIn", link: "https://www.linkedin.com/in/prathameshshete" },
  { label: "GitHub", link: "https://github.com/pratham4544" },
  { label: "YouTube", link: "https://www.youtube.com/@prathameshshete2716" },
  { label: "X", link: "https://x.com/ShetePrathamesh" },
  { label: "Instagram", link: "https://www.instagram.com/prathameshshete/" },
  { label: "Facebook", link: "https://www.facebook.com/p/prathameshshete99" },
  { label: "Pinterest", link: "https://in.pinterest.com/prathamesh_shete/" },
  { label: "Email", link: "mailto:prathameshshete609@gmail.com" },
  { label: "Call", link: "tel:+919970939341" },
  { label: "WhatsApp", link: "https://wa.me/919970939341" }
];

export const youtubeChannelId = "UCaKJeaTA-ydD_ULWD-ipCKA";
